import React from 'react';
import { Linking } from 'react-native';

export const ANDROID_NOTIFICATION_SETTINGS_ACTION = 'android.settings.APP_NOTIFICATION_SETTINGS';
export const ANDROID_APP_PACKAGE_EXTRA = 'android.provider.extra.APP_PACKAGE';

export const openNotificationSettings =
  (linking: typeof Linking) =>
  (): Promise<void> => {
    return linking.openSettings();
  };

export const hasNotificationPermission = async (): Promise<boolean> => false;

export const shouldShowNotificationPermissionBanner = (): boolean => false;

function NotificationPermissionBanner(): React.JSX.Element | null {
  return null;
}

export default NotificationPermissionBanner;
